import {combineReducers} from "redux";
import {routerReducer} from "react-router-redux";
import {reducer as Settings} from "./Setting";
import {reducer as Auth} from "./Auth";
import {reducer as User} from "./User";
import { reducer as Message } from "./Messages";
import { reducer as Products } from "./Products";
import { reducer as Orders } from './Orders';
import { reducer as Affiliates } from './Affiliates';
import { reducer as AffiliationRequests } from './AffiliationRequests';
import { reducer as Invoices } from './Invoices'


const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  user: User,
  message: Message,
  products: Products,
  orders: Orders,
  affiliates: Affiliates,
  affiliationRequests: AffiliationRequests,
  invoices: Invoices,
});

export default reducers;
